import { gsap } from 'gsap';
import { initializeTableSorter } from './stats-table.js';

/**
 * Miscellaneous UI event handlers that don't belong to a specific data module:
 *   - prime-match-header navigation
 *   - child-pages toggle
 *   - check-if-article redirect
 *   - stats table expander / tooltip
 *   - match-stats-expander / player-stats-expander
 *   - match-stats-checkbox (periodized stats row visibility)
 *   - prime-combine-selected button
 *   - secondary nav select (table selector, href selector)
 *   - deferred tab load (shown.bs.tab)
 *   - image gallery slideshow
 *   - video thumbnail player
 *   - has-menu button (stats page navigation)
 *   - post-selector-button (club tabs)
 *   - player card downloader
 *   - sortPlayersByOrder utility
 */

export function initUI() {

  // ─── Globals ──────────────────────────────────────────────────────────────

  window.sortPlayersByOrder = function(a, b) {
    return parseInt($(a).attr('data-player-number')) - parseInt($(b).attr('data-player-number'));
  };

  window.currentMatchOpen  = undefined;
  window.currentTrigger    = undefined;
  window.currentMatchHeader = undefined;
  window.oTheActiveButton  = undefined;
  window.bThePageing       = false;
  window.iTheCurrentSiteID = 0;
  window.scrollDirection   = 'none';

  // ─── Match header navigation ──────────────────────────────────────────────

  $(document).on('click', '.prime-match-header[data-href]', function() {
    if ($(this).attr('data-target') === '_blank') {
      window.open($(this).attr('data-href'), '_blank').focus();
    } else {
      window.location.href = $(this).attr('data-href');
    }
  });

  // ─── Child pages toggle ───────────────────────────────────────────────────

  $(document).on('click', '.child-pages > div', function() {
    $(this).closest('.child-pages').toggleClass('-is-active');
  });

  // ─── Check if match has article before navigating ─────────────────────────

  $(document).on('click', '.check-if-article', function(e) {
    e.preventDefault();
    const iTheID    = $(this).attr('data-id');
    const sTheURI   = $(this).attr('href');
    const sTheRestURI = '/wp-json/kaia/v1/match-article/?match_id=' + iTheID + '&category=' + $(this).attr('data-type');

    $.get(sTheRestURI, function(data) {
      window.location.href = (data && data.link) ? data.link : sTheURI;
    }).fail(function() {
      window.location.href = sTheURI;
    });
  });

  // ─── Stats table row expander ─────────────────────────────────────────────

  $(document).on('click', '.prime-stats-table button.stats-expander', function() {
    const iTheID = $(this).closest('tr').attr('data-tournament-id');
    if ($(this).hasClass('-is-open')) {
      $('tr.prime-stats-expandable[data-tournament-id=' + iTheID + ']').addClass('-is-hidden');
      $(this).removeClass('-is-open').find('span').html('Mer info');
    } else {
      $('tr.prime-stats-expandable[data-tournament-id=' + iTheID + ']').removeClass('-is-hidden');
      $(this).addClass('-is-open').find('span').html('Lukk');
    }
  });

  // ─── Stats table column sort highlight ───────────────────────────────────

  $(document).on('click', '.prime-stats-table th, .prime-stats-table th span', function() {
    const idx = $(this).closest('th').index() + 1;
    $(this).closest('table').find('tbody td').removeClass('-is-sorted');
    $(this).closest('table').find('tbody td:nth-child(' + idx + ')').addClass('-is-sorted');
  });

  // ─── Stats table column tooltip ───────────────────────────────────────────

  $(document).on('mouseenter', '.prime-stats-table th', function() {
    const tooltip = $(this).attr('data-title');
    if (!tooltip || tooltip.length === 0) return;

    const offset          = $(this).offset();
    const containerOffset = $(this).closest('.prime-stats-table-container').offset();
    const xPos            = (offset.left - containerOffset.left) + ($(this).innerWidth() / 2);

    $(this).closest('.prime-stats-table-container').find('.tooltip')
      .html(tooltip).addClass('-is-active').css({ left: xPos + 'px' });
  });

  $(document).on('mouseleave', '.prime-stats-table th', function() {
    $(this).closest('.prime-stats-table-container').find('.tooltip')
      .html('').removeClass('-is-active');
    $(this).find('span').removeClass('d-none');
  });

  // ─── Stats cells expander ─────────────────────────────────────────────────

  $(document).on('click', '.stats-expander', function() {
    $(this).closest('.prime-stats-table-container').find('.secondary').toggleClass('d-none').toggleClass('-is-active');
    $(this).toggleClass('active');
  });

  // ─── Match stats expander ─────────────────────────────────────────────────

  $(document).on('click', '.match-stats-expander', function() {
    const $next = $(this).next('.match-stats').length
      ? $(this).next('.match-stats')
      : $(this).next('.prime-roster-all');

    if ($next.length) {
      $next.toggleClass('d-none');
      $(this).toggleClass('-do-reveal').toggleClass('-do-hide');
    }
  });

  // ─── Player stats expander ────────────────────────────────────────────────

  $(document).on('click', '.player-stats-expander', function() {
    if ($(this).next('.prime-stats-container').length > 0) {
      $(this).next('.prime-stats-container').toggleClass('d-none').toggleClass('d-flex');
      $(this).toggleClass('-do-reveal').toggleClass('-do-hide');
    }
  });

  // ─── Periodized stats checkbox ────────────────────────────────────────────

  $(document).on('change', 'input.match-stats-checkbox', function() {
    const iTheMatchID = $(this).attr('data-match-id');
    if ($(this).prop('checked')) {
      $('.prime-periodized-stats-table').find('tr[data-match-id=' + iTheMatchID + ']').removeClass('-is-hidden').addClass('-is-visible');
    } else {
      $('.prime-periodized-stats-table').find('tr[data-match-id=' + iTheMatchID + ']').addClass('-is-hidden').removeClass('-is-visible');
    }
    // Re-stripe visible rows
    $('.prime-periodized-stats-table').find('tr.-is-visible').each(function(i) {
      $(this).toggleClass('-is-even', i % 2 === 0).toggleClass('-is-odd', i % 2 !== 0);
    });
  });

  // ─── Combine selected matches ─────────────────────────────────────────────

  $(document).on('click', '.prime-combine-selected', function() {
    const combineBtn = $(this);
    const aTheData   = [];
    window.aTheData  = aTheData;

    combineBtn.prop('disabled', 'disabled');
    $('.prime-data.merged-matches').empty().addClass('-is-loading').append(window.sTheLoader);

    combineBtn.closest('.prime-data').find('label').each(function() {
      if ($(this).find('.match-stats-checkbox').prop('checked')) {
        aTheData.push($(this).find('.match-stats-checkbox').attr('data-match-id'));
      }
    });

    window.Ajax.mergeMatches(
      { template: 'stats/merged.php', container: '.prime-data.merged-matches', data: aTheData },
      function(data) {
        $(data.param.container).empty().append(data.markup);
        initializeTableSorter('body');
        combineBtn.prop('disabled', false).removeProp('disabled');
      },
      function(data) { window.showError(data); }
    );
  });

  // ─── Secondary nav select (table selector / href) ─────────────────────────


  const sTheInitialArchiveHref = $('.archive-link').attr('href');
  console.log(sTheInitialArchiveHref);

  $(document).on('change', '.prime-secondary-nav select', function() {
    if ($(this).closest('.prime-secondary-nav').hasClass('table-selector')) {
      const iTheID = $(this).find('option:selected').attr('data-id');
      window.location.href = '/tabell/?tournament=' + iTheID;
    } else if ($(this).find('option:selected').attr('data-href')) {
      window.location.href = $(this).find('option:selected').attr('data-href');
    }
    // Note: #news_selector is handled separately in frontpage.js
  });

  // ─── Deferred tab load ────────────────────────────────────────────────────

  $(document).on('shown.bs.tab', '.nav-tabs button', function() {
    const tabId = $(this).attr('data-bs-target');
    if ($(tabId).find('.prime-data-defer').length === 0) return;

    const sTheContainer = $(tabId).find('.prime-data-defer').attr('data-content-container');
    const oTheContainer = $(sTheContainer);
    oTheContainer.empty().append(window.sTheLoader);

    window.Ajax.prime_v2(
      {
        template   : oTheContainer.attr('data-content-template'),
        id         : oTheContainer.attr('data-id'),
        queryString: oTheContainer.attr('data-content-query'),
        queryType  : oTheContainer.attr('data-query-type'),
        homeTeam   : oTheContainer.attr('data-home-team'),
        awayTeam   : oTheContainer.attr('data-away-team'),
        match      : oTheContainer.attr('data-match'),
        container  : oTheContainer.attr('data-content-container'),
      },
      function(data) {
        if (data.count > 0) {
          $(data.param.container).empty().append(data.markup);
          oTheContainer.removeClass('prime-data-defer').addClass('prime-data');
          oTheContainer.find('.prime-match-pitch-stats-table').tablesorter({ sortList: [[3, 1]], sortInitialOrder: 'desc' });
          oTheContainer.find('.prime-match-pitch-stats-table tbody td:nth-child(4)').addClass('-is-sorted');
          oTheContainer.find('.prime-match-goalie-stats-table').tablesorter({ sortList: [[2, 1]], sortInitialOrder: 'desc' });
          oTheContainer.find('.prime-match-goalie-stats-table tbody td:nth-child(3)').addClass('-is-sorted');
        }
      },
      function(data) { window.showError(data); }
    );
  });

  // ─── Image gallery slideshow ──────────────────────────────────────────────

  $('.image-container.-is-gallery').each(function() {
    const images       = $(this).find('img');
    let currentIndex   = 0;

    gsap.set(images, { opacity: 0 });
    gsap.set(images[0], { opacity: 1 });
    $(this).find('.indicators .indicator').eq(0).addClass('active');

    $('.indicator').on('click', function() {
      const index = $(this).attr('data-index') * 1;
      if (index === currentIndex) return;

      gsap.to(images[currentIndex], { opacity: 0, duration: 0.5 });
      gsap.to(images[index],        { opacity: 1, duration: 0.5 });

      $(this).closest('.image-container').find('.indicator').removeClass('active');
      $(this).addClass('active');
      currentIndex = index;
    });
  });

  // ─── Video thumbnail player ───────────────────────────────────────────────

  $(document).on('click', '.thumbnail-overlay-container', function() {
    const sTheVideoURI = $(this).find('video').attr('data-video-uri');
    const oThePlayer   = $(this).find('video')[0];
    if (!sTheVideoURI || sTheVideoURI.length === 0) return;

    if (oThePlayer.paused || $(this).find('video').attr('data-status') === 'can-play') {
      $(this).find('video').css({ 'z-index': 2, opacity: 1 }).attr('data-status', 'can-pause');
      oThePlayer.src = sTheVideoURI;
      oThePlayer.play();
    } else if ($(this).find('video').attr('data-status') === 'can-pause') {
      oThePlayer.pause();
      $(this).find('video').css({ 'z-index': 1, opacity: 0 }).attr('data-status', 'can-play');
    }
  });

  // ─── Stats page menu button ───────────────────────────────────────────────

  $(document).on('click', '.-has-menu button', function() {
    const expanded = $(this).attr('aria-expanded') === 'true';
    $(this).attr('aria-expanded', !expanded);
    $(this).closest('.-has-menu').find('.prime-pages-list').toggleClass('-is-open');
  });

  // ─── Club / multi-site post selector ─────────────────────────────────────

  $('.post-selector-button').click(function(e) {
    e.preventDefault();
    const iTheID = $(this).attr('data-blog-id') * 1;
    let all = 0;

    $(this).closest('.filter-container').find('.all-posts .single-archive-article').each(function() {
      if (all < 19 && ($(this).attr('data-site-id') * 1 === iTheID || iTheID === 0)) {
        $(this).addClass('-is-visible').removeClass('-is-hidden');
        window.iTheCurrentSiteID = iTheID;
        all++;
      } else {
        $(this).addClass('-is-hidden').removeClass('-is-visible');
      }
    });
  });

  // ─── Player card downloader ───────────────────────────────────────────────

  $(document).on('click', '.player-card-downloader', function() {
    const { saveAs } = window; // expects file-saver on window, or import at top if bundled
    const Urlbox     = window.Urlbox;

    const urlbox   = Urlbox('ExCYItcVjoH4b2FI', 'bb6a0da115d243e48c308b0793ec656b');
    const dt        = new Date();
    const selector  = '#' + $(this).closest('.prime-single-player-card').find('.card-container').attr('id');

    let url = window.location.protocol + '//' + window.location.hostname
      + '/spillerkort/?player_id=' + $(this).attr('data-player')
      + '&type=' + $(this).attr('data-type');

    if ($(this).attr('data-tournament')) {
      url += '&context_id=' + $(this).attr('data-tournament');
    }
    url += '&dt=' + dt.getTime();

    const imgUrl = urlbox.buildUrl({ url, width: 1080, height: 1920, thumb_width: 1080, format: 'jpg', quality: 100 });
    saveAs(imgUrl, selector + '.jpg');
  });

  // ─── Final resize call ────────────────────────────────────────────────────
  window.doResize();
}



// WEBPACK FOOTER //
// ./scripts/routes/common/ui.js